import {Icon} from '@wandb/components';
import React from 'react';

type RowBaselineProps = {
  isRowBaseline: boolean;
  isSingleMode: boolean;
  onRemoveBaseline: () => void;
};

export function RowBaseline({isRowBaseline, isSingleMode}: RowBaselineProps) {
  if (isSingleMode || !isRowBaseline) {
    return null;
  }

  return (
    <div className="flex shrink-0 w-24 justify-center">
      <Icon icon="bookmark-alt" />
    </div>
  );
}
